export const pickParticipationLabel = (itemType?: string) => {
  switch (itemType) {
    case 'Physician':
      return "Physician"
    case 'Clinic':
      return "Clinic"
    case 'Hospital':
      return "Hospital"
    case 'Ohcp':
      return 'Advanced Practice Provider'
    case 'Nfp':
      return 'Non-For-Profit'
    default:
      return "User"
  }
}
